module.exports = __webpack_public_path__ + "img/1.9_Russian_road_sign.3058b4af.svg";